module.exports = __webpack_public_path__ + "img/detail-ticket.7edf7610.svg";